import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select'
import { cn } from '@/lib/utils'
import {
  channelStripeClass,
  getDeviceLabel,
  getDeviceState,
  stateDotClass,
} from '@/lib/devices'

interface DevicePickerProps {
  devices?: any[]
  value: string
  onChange: (id: string) => void
  id?: string
  isLoading?: boolean
}

export function DeviceRow({ device }: { device: any }) {
  const { state, word } = getDeviceState(device)
  return (
    <span className='flex items-center gap-2 min-w-0'>
      <span className={cn('h-4 w-[3px] rounded-full flex-shrink-0', channelStripeClass(device))} aria-hidden='true' />
      <span className='truncate'>{getDeviceLabel(device)}</span>
      <span className='flex items-center gap-1 text-xs text-muted-foreground flex-shrink-0'>
        <span className={cn('h-2 w-2 rounded-full', stateDotClass[state])} aria-hidden='true' />
        {word}
      </span>
    </span>
  )
}

export default function DevicePicker({ devices = [], value, onChange, id, isLoading }: DevicePickerProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger id={id}>
        <SelectValue placeholder='Choose a sender' />
      </SelectTrigger>
      <SelectContent>
        {isLoading ? (
          <SelectItem value='loading' disabled>Loading senders…</SelectItem>
        ) : devices.length > 0 ? (
          devices.map((device: any) => (
            <SelectItem key={device.id} value={device.id} disabled={!device.enabled}>
              <DeviceRow device={device} />
              {!device.enabled && <span className='text-xs text-muted-foreground ml-2'>turned off</span>}
            </SelectItem>
          ))
        ) : (
          <SelectItem value='no-devices' disabled>No senders yet. Add one on the Senders page.</SelectItem>
        )}
      </SelectContent>
    </Select>
  )
}
